var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 145 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.340785, 0.556033)",
    style: {
      fill: "var(--tab-icon-fill-color, #fff)"
    },
    strokeWidth: 1,
    fillRule: "evenodd",
    stroke: "currentcolor"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 3,
    transform: "translate(72.159215, 29.443967) rotate(-2.000000) translate(-72.159215, -29.443967) ",
    x: 3.15921511,
    y: 3.94396685,
    width: 138,
    height: 51,
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(35.159215, 91.943967) rotate(-5.000000) translate(-35.159215, -91.943967) ",
    x: 2.15921511,
    y: 71.9439668,
    width: 66,
    height: 40,
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 3,
    x: 3.15921511,
    y: 127.943967,
    width: 64,
    height: 35,
    rx: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 5,
    transform: "translate(111.659215, 101.443967) rotate(3.000000) translate(-111.659215, -101.443967) ",
    x: 83.1592151,
    y: 69.9439668,
    width: 57,
    height: 63,
    rx: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(111.659215, 166.943967) rotate(-4.000000) translate(-111.659215, -166.943967) ",
    x: 81.1592151,
    y: 148.943967,
    width: 61,
    height: 36,
    rx: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.76add8125502925713dd339ce50d41b2.svg";
export { ForwardRef as ReactComponent };